import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#C8C4B7]">Signing you in…</div>;
}
